<h3 class="h5">Average Test Mark</h3>
<span id="avgscore" class="display-4 d-block text-blue">{{quizStatistics.averageScore}}%</span>
<p class="mb-2 stats-text">Average mark at your last attempt at each test.</p>
<div class="d-flex flex-row align-items-left">
            <i class="fas fa-fw fa-info-circle fa-2x btn-blue"></i> 
            <a class="hintLink" (click)="showModal()">How was this calculated?</a>
          </div>